// include CAMUNDA specific constants here

const WAIT_FOR_TERMINATION_TIMER_ID = 'WarteAufKundigungsdatumEvent';

export {
  WAIT_FOR_TERMINATION_TIMER_ID
}
